import clsx from "clsx";
import { Link } from "@inertiajs/react";
import { product_path } from "@/routes.js";
import formatMoney from "../../utils/formatMoney.js";
import AddToCart from "../cart/AddToCart.jsx";
import AddToCartExperemental from "../cart/AddToCartExperemental.jsx";
import { Card, CardContent } from "~/components/ui/card";
import { cn } from "../../lib/utils.js";

const MINI_FIGURE_SEGMENT = "folghirovannyie-mini-fighury";

export default function ProductCard({ product, cover = false }) {
  const [image] = cover ? product.product_cover_images : product.product_images;

  const isMiniFigure = product.taxons?.some((t) =>
    t.permalink?.includes(MINI_FIGURE_SEGMENT)
  );

  return (
    <Card className="p-0 overflow-hidden">
      <CardContent className={cn("px-0 py-0")}>
        <div className={cn(!cover && "m-4 rounded overflow-hidden")}>
          <Link href={product_path(product.slug)}>
            <img
              src={image.url}
              width={image.width}
              height={image.height}
              loading="lazy"
              alt={product.name}
            />
          </Link>
        </div>
        <div className="p-2 xl:p-4 space-y-3">
          <div className="text-lg font-medium line-clamp-[4.5rem] h-[3rem] leading-[1.5rem]">
            <Link href={product_path(product.slug)}>{product.name}</Link>
          </div>
          {isMiniFigure && (
            <p className="text-sm text-gray-500">Мини-фигуры, надутые воздухом, на палочку</p>
          )}
          <div className="text-gray-500 font-bold">
            {formatMoney(product.price)}
          </div>
          <AddToCart product={product} />
        </div>
      </CardContent>
    </Card>
  );
}
